import ROUTE from '@shared/modules/assessment/router/names'
import routes from '@shared/modules/assessment/router/routes'
import hooks from '@shared/modules/assessment/router/hooks.js'

export default {
  ROUTE,
  routes,
  hooks,
}
